import {useMatchMedia} from '@pexip/hooks';

import {LG_UP} from '../../constants/mediaQueries';

export const useLgUp = () => useMatchMedia(LG_UP);
